<template>
    <div>
        <div v-if="pageCount<maxPageShow-1" v-show="pageCount>1" class="airtime_pagination">
            <button class="page_btn" :disabled="currentPage < 2"
                    @click="changeCurrentPage(currentPage-1)"><
            </button>
            <button v-for="page in pageCount" class="page_btn" :class="{active:currentPage === page}"
                    @click="changeCurrentPage(page)">{{page}}
            </button>
            <button class="page_btn" :disabled="currentPage > pageCount - 1"
                    @click="changeCurrentPage(currentPage+1)">>
            </button>
        </div>
        <div v-else-if="currentPage < Math.ceil(maxPageShow/2) + 1" v-show="pageCount>1" class="airtime_pagination">
            <button class="page_btn" :disabled="currentPage < 2"
                    @click="changeCurrentPage(currentPage-1)"><
            </button>
            <button v-for="page in Math.ceil(maxPageShow/2)" class="page_btn" :class="{active:currentPage === page}"
                    @click="changeCurrentPage(page)">{{page}}
            </button>
            <span> ... </span>
            <button class="page_btn" :class="{active:currentPage === pageCount-1}"
                    @click="changeCurrentPage(pageCount - 1)">{{pageCount-1}}
            </button>
            <button class="page_btn" :class="{active:currentPage === pageCount}" @click="changeCurrentPage(pageCount)">
                {{pageCount}}
            </button>
            <button class="page_btn" :disabled="currentPage > pageCount - 1"
                    @click="changeCurrentPage(currentPage+1)">>
            </button>
        </div>
        <div v-else-if="currentPage > Math.ceil(maxPageShow/2) && currentPage < (pageCount + 1) - Math.ceil(maxPageShow/2)"
             v-show="pageCount>1" class="airtime_pagination">
            <button class="page_btn" :disabled="currentPage < 2"
                    @click="changeCurrentPage(currentPage-1)"><
            </button>
            <button class="page_btn" :class="{active:currentPage === 1}" @click="changeCurrentPage(1)">1</button>
            <button class="page_btn" :class="{active:currentPage === 2}" @click="changeCurrentPage(2)">2</button>
            <span> ... </span>
            <button class="page_btn" :class="{active:currentPage === currentPage-1}"
                    @click="changeCurrentPage(currentPage-1)">{{currentPage-1}}
            </button>
            <button class="page_btn" :class="{active:currentPage === currentPage}"
                    @click="">{{currentPage}}
            </button>
            <button class="page_btn" :class="{active:currentPage === currentPage+1}"
                    @click="changeCurrentPage(currentPage+1)">{{currentPage+1}}
            </button>
            <span> ... </span>
            <button class="page_btn" :class="{active:currentPage === pageCount-1}"
                    @click="changeCurrentPage(currentPage -1 )">{{pageCount-1}}
            </button>
            <button class="page_btn" :class="{active:currentPage === pageCount}" @click="changeCurrentPage(pageCount)">
                {{pageCount}}
            </button>
            <button class="page_btn" :disabled="currentPage > pageCount - 1"
                    @click="changeCurrentPage(currentPage+1)">>
            </button>
        </div>
        <div v-else="" v-show="pageCount>1" class="airtime_pagination">
            <button class="page_btn" :disabled="currentPage < 2"
                    @click="changeCurrentPage(currentPage-1)"><
            </button>
            <button class="page_btn" :class="{active:currentPage === 1}" @click="changeCurrentPage(1)">1</button>
            <button class="page_btn" :class="{active:currentPage === 2}" @click="changeCurrentPage(2)">2</button>
            <span> ... </span>
            <button v-for="page in Math.ceil(maxPageShow/2)" class="page_btn"
                    :class="{active:currentPage === pageCount - (Math.ceil(maxPageShow/2) - page)}"
                    @click="changeCurrentPage(pageCount - (Math.ceil(maxPageShow/2) - page))">{{pageCount -
                (Math.ceil(maxPageShow/2) - page)}}
            </button>
            <button class="page_btn" :disabled="currentPage > pageCount - 1"
                    @click="changeCurrentPage(currentPage+1)">>
            </button>
        </div>

    </div>
</template>

<script>
    export default {
        props: {
            pageCount: Number,
            currentPage: Number,
            maxPageShow: {
                type: Number,
                default: 10
            },
        },
        model: {
            prop: 'currentPage',
            event: 'change'
        },
        data() {
            return {

            }
        },
        mounted() {
        },
        methods: {
            changeCurrentPage(currentPage) {
                this.$emit('change', currentPage)
            }
        }
    }
</script>